import React, { useState } from 'react';
import { getTodayKST } from 'utils';

interface IProps {
  closeModal: () => void;
  // 부모가 dim/정렬 컨테이너를 제공하는 경우(데스크톱 나란히 배치) dim 레이어를 생략
  embedded?: boolean;
}

// 멤버십(단독 구매 상품) 신규/연장 구매 종료 안내 팝업 (DDPS 요청, 2026-06)
const MembershipClosureNotice: React.FC<IProps> = ({
  closeModal,
  embedded = false,
}: IProps) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleDontShowAgain = () => {
    setDontShowAgain(!dontShowAgain);
  };

  const handleClose = () => {
    if (dontShowAgain) {
      // 당일(KST) 자정까지 노출 안 함
      localStorage.setItem(
        'hideLocalStitchMembershipClosurePopup',
        getTodayKST(),
      );
    }
    closeModal();
  };

  return (
    <div className={embedded ? 'popup-bare' : 'dimd-layer'}>
      <div className="announcement-popup">
        <div className="announcement-header">
          <h2>
            로컬스티치 멤버십 신규구매 및 연장구매(월 12만원 단독 구매 상품)
            종료 안내
          </h2>
          <button type="button" className="btn-close" onClick={handleClose}>
            <span className="img-close" />
          </button>
        </div>

        <div className="announcement-content">
          <div className="announcement-text">
            <p>안녕하세요. 로컬스티치입니다.</p>
            <p>그동안 로컬스티치 멤버십을 이용해주신 분들께 감사드립니다.</p>
            <p className="spacing" />
            <p>
              본 안내는 공간 계약에 따라 제공되는 멤버십 권한이 아닌, 홈페이지를
              통해 별도로 구매해 이용하던 로컬스티치 멤버십(단독 구매 상품)에
              대한 안내입니다.
            </p>
            <p className="spacing" />
            <p>
              로컬스티치는 운영 정책 변경에 따라 로컬스티치 멤버십(단독 구매
              상품)의 신규구매 및 연장구매를 순차적으로 종료하게 되었습니다.
            </p>
            <p className="spacing" />
            <p>
              이에 따라 <strong>2026년 6월 26일</strong>부터 로컬스티치
              멤버십(단독 구매 상품)의 신규구매가 종료되며,{' '}
              <strong>2026년 7월 1일</strong>부터는 기존 이용 고객의 연장구매가
              종료됩니다.
            </p>
            <p className="spacing" />
            <p>
              기존에 결제하신 로컬스티치 멤버십(단독 구매 상품)은 보유하신
              이용기간 만료일까지 정상 이용하실 수 있습니다.
            </p>
            <p>
              다만 2026년 7월 시작일로 사전 구매된 로컬스티치 멤버십(단독 구매
              상품) 건은 별도 안내 후 결제 취소 및 환불 처리될 예정입니다.
            </p>
            <p className="spacing" />
            <p>갑작스러운 안내로 이용에 불편을 드리게 된 점 양해 부탁드립니다.</p>
            <p>
              남은 이용기간 동안 기존 혜택을 정상적으로 이용하실 수 있도록 안내와
              운영에 최선을 다하겠습니다.
            </p>
            <p className="spacing" />
            <p>이용 관련 문의는 채널톡을 통해 남겨주시기 바랍니다.</p>
            <p>감사합니다.</p>
            <p className="signature">로컬스티치 드림</p>
          </div>

          <div className="dont-show-again">
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                id="dontShowMembershipClosure"
                checked={dontShowAgain}
                onChange={handleDontShowAgain}
              />
              <label htmlFor="dontShowMembershipClosure">오늘 하루 그만보기</label>
            </div>
            <button type="button" onClick={handleClose}>
              닫기
            </button>
          </div>
        </div>
      </div>
      <style jsx>{`
        .dimd-layer {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          z-index: 1000;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }

        /* 부모(데스크톱 나란히 배치 컨테이너)가 dim/정렬을 담당하는 경우 */
        .popup-bare {
          display: flex;
        }

        /* 나란히 배치 시 두 팝업이 화면을 나눠 갖도록 폭 축소 */
        .popup-bare .announcement-popup {
          max-width: 520px;
          max-height: 86vh;
        }

        .announcement-popup {
          position: relative;
          background-color: white;
          width: 100%;
          max-width: 650px;
          max-height: 90vh;
          overflow-y: auto;
          padding: 40px 30px;
          border-radius: 0;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .announcement-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 12px;
          margin-bottom: 25px;
        }

        .btn-close {
          position: static;
          background: none;
          border: none;
          cursor: pointer;
          line-height: 1;
          width: 30px;
          height: 30px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }

        .btn-close .img-close {
          display: block;
          width: 100%;
          height: 100%;
          background-image: url('/images/x-button.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
        }

        .announcement-content {
          text-align: left;
        }

        h2 {
          font-size: 22px;
          font-weight: 700;
          text-align: left;
          letter-spacing: -0.5px;
          margin: 0;
          line-height: 1.4;
        }

        .announcement-text {
          line-height: 1.5;
          font-size: 15px;
          color: #000;
          letter-spacing: -0.5px;
          margin-bottom: 30px;
        }

        .announcement-text p {
          margin-bottom: 5px;
        }

        .spacing {
          height: 10px;
        }

        .signature {
          margin-top: 20px;
        }

        .dont-show-again {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #000;
          padding-top: 15px;
          padding-left: 0;
        }

        .checkbox-wrapper {
          display: flex;
          align-items: center;
          padding-left: 0;
          margin-left: 0;
        }

        .dont-show-again input[type='checkbox'] {
          appearance: none;
          -webkit-appearance: none;
          margin-left: 0;
          position: relative;
          cursor: pointer;
          vertical-align: middle;
        }

        .dont-show-again input[type='checkbox']:checked {
          background-color: #fff;
          border-color: #ccc;
        }

        .dont-show-again input[type='checkbox']:checked:after {
          content: '';
          position: absolute;
          left: 4px;
          top: 1px;
          width: 5px;
          height: 10px;
          border: solid #333;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }

        .dont-show-again label {
          font-size: 15px;
          height: 18px;
          line-height: 18px;
          cursor: pointer;
        }

        .dont-show-again button {
          padding-bottom: 1px;
          border-bottom: 1px solid #000;
          cursor: pointer;
          font-size: 15px;
        }

        @media (max-width: 768px) {
          .announcement-popup {
            padding: 30px 20px;
            max-height: 80vh;
          }

          h2 {
            font-size: 17px;
          }

          .announcement-text {
            font-size: 13px;
          }

          .btn-close .img-close {
            width: 20px;
            height: 20px;
          }

          .dont-show-again,
          .dont-show-again label,
          .dont-show-again button {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
};

export default MembershipClosureNotice;
